import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Referral } from './referral'

export class ReferralsRepository extends BaseRepository<Referral> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.eventApiUrl + '/' + 'referrals', token, cache)
    }
}
